import { render, staticRenderFns } from "./approvesettlements.vue?vue&type=template&id=1bbce1fa"
import script from "./approvesettlements.vue?vue&type=script&lang=js"
export * from "./approvesettlements.vue?vue&type=script&lang=js"
import style0 from "./approvesettlements.vue?vue&type=style&index=0&id=1bbce1fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports